import gql from 'graphql-tag';

export const GetCreateLinkQuery = gql`
  query createLink(
    $resource: ResourceName!
    $fileName: String!
    $resourceID: String!
  ) {
    createLink(
      resource: $resource
      fileName: $fileName
      resourceID: $resourceID
    ) {
      expiry
      uri
    }
  }
`;
